import React from "react";

export default function VoiceEmotionEmbed() {
  return (
    <div style={{ maxWidth: "100%", margin: "auto", padding: "16px" }}>
      <h2 style={{ textAlign: "center", color: "#333" }}>
        🎤 Voice Emotion Recognition
      </h2>
      <iframe
        src="https://boloappde-emotion-detection-api.hf.space"
        title="Voice Emotion Detector"
        frameBorder="0"
        width="100%"
        height="520"
        allow="microphone"
        style={{
          borderRadius: 12,
          minWidth: "320px",
          boxShadow: "0 6px 16px rgba(0,0,0,0.1)",
        }}
      />
    </div>
  );
}
